"use client";

import dynamic from "next/dynamic";
import { memo } from "react";
import cn from "clsx";
import styles from "./FaqSectionHome.module.scss";
import CityListingBannerForm from "@/components/pages/CityListingPage/CityBannerForm";

const FaqWithoutCategory = dynamic(
  () => import("../../FaqSection/FaqWithCategoryProgram/Faqs"),
  { loading: () => null }
);

const LeadFormNew = dynamic(
  () => import("@/revamp/sections/HomeNewFaq/LeadFormNew/index"),
  { loading: () => null }
);

interface FaqWithFormProps {
  Faqs: any;
  associatedPrograms: any;
  isLambdaAPI?: boolean;
  testimonials?: any;
  isSpecificPage?: boolean;
  seatsFilledUI?: any;
  isProgramListPage?: boolean;
  isMobile?: boolean;
  landingPageValue?: string;
  Heading?:string
  isCityPage?:boolean
  RFIHeading?:string
}

const FaqWithForm: React.FC<FaqWithFormProps> = ({
  Faqs,
  associatedPrograms,
  isLambdaAPI,
  isSpecificPage = false,
  seatsFilledUI,
  isProgramListPage,
  isMobile,
  landingPageValue = "",
  Heading="",
  isCityPage=false,
  RFIHeading=""
}) => {
  return (
    <>
      <section className={cn(styles.container, "lining-nums" ,isCityPage && styles.cityPage)}>
        <div
          className={`${isSpecificPage ? styles.layoutSpecific : styles.layout} ,${isLambdaAPI ? styles.lpLayout : styles.layout}`}
        >
          <div className={styles["faq-section"]}>
            {Faqs && <FaqWithoutCategory isHome={true} {...Faqs} />}
          </div>
          <div className={styles["lead-form-section"]}>
            <div className={cn("form-wrapper", styles.formSection)}>
              {isCityPage ?  <CityListingBannerForm  RFIHeading={RFIHeading}  associatedPrograms={associatedPrograms}  isSeatsFilledUI={false} />
              :
              <LeadFormNew
              isSpecificPage={isSpecificPage}
              isLambdaAPI={isLambdaAPI}
              associatedPrograms={associatedPrograms}
              seatsFilledUI={
                seatsFilledUI?.Seats > 0 ? seatsFilledUI.Seats : 87
              }
              Heading={Heading}
              isSeatsFilledUI={seatsFilledUI?.enabled}
              isProgramListPage={isProgramListPage}
              isMobile={isMobile}
              landingPageValue={landingPageValue}
            />
              }
             
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default memo(FaqWithForm);
